import { R } from '@/modules/api/actions'

export const logout = async () => {
    try {
        await R.logout()
    } catch (error) {
        console.error('Logout error', error)
    }
}
